import { useRescheduleKontaktaufnahme as useRescheduleKontaktaufnahmeApi } from '../../client/hooks';
import { useSnackbar } from 'notistack';
import { useQueryClient } from 'react-query';
import { useTranslation } from 'react-i18next';

export const useRescheduleKontaktaufnahme = () => {
    const rescheduleApi = useRescheduleKontaktaufnahmeApi();
    const { enqueueSnackbar } = useSnackbar();
    const queryClient = useQueryClient();
    const { t: translation } = useTranslation('kontakte');

    return async (kontaktaufnahmeId: string, options?: { newStart?: string; immediate?: boolean }) => {
        try {
            await rescheduleApi(kontaktaufnahmeId, options);

            await queryClient.invalidateQueries(['kontakte-view']);

            enqueueSnackbar(translation('reschedule-success'), { variant: 'success' });
        } catch (error: unknown) {
            console.error('Error rescheduling Kontaktaufnahme:', error);
            enqueueSnackbar(
                error instanceof Error ? error.message : translation('reschedule-error'),
                { variant: 'error' }
            );
            throw error;
        }
    };
};

